import { FC } from "react";
import _t from "../lang/translate";

const BetaBadge: FC = () => {
  return <span className="status-badge status-badge-blue-outline">{_t('beta')}</span>;
};

export default BetaBadge;
